import pathToRegexp from 'path-to-regexp'
import cloneDeep from 'lodash/cloneDeep'
import routeConfigs from '../../config/routes'

// 匹配路由
export const matchParamsPath = (pathname, breadcrumbNameMap = {}) => {
  const pathKey = Object.keys(breadcrumbNameMap).find((key) => pathToRegexp(key).test(pathname))
  return breadcrumbNameMap[pathKey]
}

// 获取第一个路由
export const getFirstRoute = (menu) => {
  const firstRoute = (menu && menu[0]) || {}
  if (firstRoute && firstRoute.children && firstRoute.children.length) {
    return getFirstRoute(firstRoute.children)
  }
  return firstRoute || {}
}

// 获取子路由
export const getRoutesByPath = (path) => {
  const route =
    routeConfigs.find((route) => {
      return route.path === path
    }) || {}
  return route.routes || []
}

// 格式化 route 数据,子路由 若不存在权限字段，则继承 父路由
export const formatRoute = (data, parent = {}) => {
  return data
    .map((route) => {
      // 过滤 非菜单路由
      if (route.redirect || !route.path) {
        return null
      }

      // 避免修改 route 引用
      let item = route

      item = {
        ...item,
        name: item.name || parent.name,
        hideHeader: item.hideHeader || parent.hideHeader,
        hideInMenu: item.hideInMenu || parent.hideInMenu,
        hidePlatform: item.hidePlatform || parent.hidePlatform,
      }

      if (item.routes && item.routes.length) {
        const routes = formatRoute(item.routes, item)
        item.children = routes
      }
      return item
    })
    .filter((item) => item) // 过滤为null的情况
}

// 过滤菜单路由
export const filterMenuData = (menuData, roleName, features) => {
  if (!menuData) {
    return []
  }
  const data = menuData
    .filter((item) => {
      const { name, hideInMenu, path } = item
      // 隐藏子菜单
      if (!name || hideInMenu) {
        return false
      }

      //不能查看员工管理
      if (roleName === 'trainer' && path === '/system/person/manage') {
        return false
      }

      //不能查看用户组   ｜｜没有开启用户组的能力
      if (
        (roleName === 'trainer' || !features?.includes('barracks.system.user')) &&
        path === '/system/person/user'
      ) {
        return false
      }

      //不能查看ai导师评价维度
      if (roleName === 'trainer' && path === '/system/person/appraise') {
        return false
      }

      //不能查看工具库
      if (roleName === 'trainer' && path === '/bank/toolsPage') {
        return false
      }

      // 过滤工具使用页面
      if (path === '/bank/toolsPage/useTools') {
        return false
      }

      if (path === '/bank/story' && roleName === 'trainer') {
        return false
      }

      if (path === '/workbench/dashboard' && roleName === 'trainer') {
        return false
      }

      // 客服不能查看工作台和题库管理
      if (path === '/bank' && roleName === 'trainer') {
        return false
      }

      if (path === '/workbench' && roleName === 'trainer') {
        return false
      }

      // 产品后台管理权限
      if (path === '/bank/case' && !features?.includes('barracks.case')) {
        return false
      }

      if (path === '/bank/toolsPage' && !features?.includes('barracks.tool')) {
        return false
      }

      // 不能查看会话案例页面
      const hasPermit =
        (roleName === 'trainer' && path.indexOf('/case') === -1) ||
        // (roleName === 'trainer' && path.indexOf('/system/person/manage') === -1) ||
        roleName === 'admin'

      return hasPermit
    })
    .map((item) => {
      if (item.children) {
        item.children = filterMenuData(item.children, roleName, features)
      }
      return item
    })
  return data
}

// 获取面包屑映射
export const getBreadcrumbMap = (menuData) => {
  const routerMap = {}

  const flattenMenuData = (data) => {
    data.forEach((menuItem) => {
      routerMap[menuItem.path] = menuItem

      if (menuItem.children) {
        flattenMenuData(menuItem.children)
      }
    })
  }
  flattenMenuData(menuData)
  return routerMap
}

// 获取路由映射
export const getRouterMap = (routes) => {
  const routerMap = {}

  const flattenMenuData = (data, parent = {}) => {
    data.forEach((menuItem) => {
      routerMap[menuItem.path] = { ...menuItem }
      if (menuItem.routes) {
        flattenMenuData(menuItem.routes, routerMap[menuItem.path])
      }
    })
  }
  flattenMenuData(routes)
  return routerMap
}

// 获取 menuModel state
export const routes = getRoutesByPath('/')
const routeData = formatRoute(cloneDeep(routes))
export const breadcrumbs = getBreadcrumbMap(cloneDeep(routeData))

export const getMenuState = (roleName: string, features: string[]) => {
  const routeMap = getRouterMap(routes)
  const menus = filterMenuData(cloneDeep(routeData), roleName, features).filter((item) => {
    const { path, redirect, children } = item
    return (path && !redirect) || (children && children.length)
  })
  const firstRoute = getFirstRoute(menus)
  return { menus, breadcrumbs, routes: routeMap, firstRoute }
}

export const getCount = (m: string, mixed: string[]) => {
  let count = 0
  mixed.forEach((item) => {
    if (`/${item.split('/')[1]}` === m) {
      count += 1
    }
  })
  return count
}

export const getRoleAuthData = (roleData: any) => {
  const level: string[] = []
  const result = {}
  // 筛出第一层级
  roleData.forEach((item) => {
    if (!item.split('/')[2]) {
      level.push(`/${item.split('/')[1]}`)
    }
  })
  // 求差集
  const mixed = roleData.filter((item) => level.indexOf(item) === -1)
  // 在mixed中找到以level开头的孩子的数量
  let num = 0
  level.forEach((m) => {
    num = getCount(m, mixed)
    result[m] = num
  })
  return result
}

export const getFinallyResult = (data: any, roleAuthData: any, mapData: any) => {
  Object.getOwnPropertyNames(roleAuthData).forEach((key1) => {
    Object.getOwnPropertyNames(mapData).forEach((key2) => {
      if (key1 === key2) {
        if (
          key1 === '/dialog' &&
          Object.keys(data).includes('/dialog/radar') &&
          roleAuthData[key1] === 2
        ) {
          delete data[key1]
        } else if (roleAuthData[key1] !== mapData[key2].children.length) {
          // 每一层级子级的个数不等于参照数据的children的个数
          delete data[key1]
        }
      }
    })
  })
  return data
}
